import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
	Row,
	Col,
	Card,
	CardBody,
	CardHeader,
	Container,
	Button,
	Table,
	FormGroup,
	InputGroup,
	InputGroupAddon,
	Input,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";

import swal from "sweetalert";
import {
	getORDERLocations,
	ORDERlocationRowData,
	ORDERlocationDelete,
	model_open,
	model_close,
	SetParams,
} from "../../../store/Masters/OrderLocations/action";
class OrderLocations extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getORDERLocations({});
	}
	// handleDelete(values) {
	// 	this.props.ORDERlocationDelete(values, this.props.history);
	// }

	deleteRecord = (locId) => {
		swal({
			title: "Are you sure?",
			text: "Once deleted, you will not be able to recover this imaginary file!",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				this.props.ORDERlocationDelete(locId);
			} else {
				swal({ title: "Your imaginary file is safe!", timer: 1500 });
			}
		});
	};

	handleSearch = (e) => {
		if (e.key === "Enter") {
			this.props.getORDERLocations({
				...this.props.params,
				page: 1,
				search: e.target.value,
			});
		}
		if (e.target.value === "") {
			this.props.getORDERLocations(
				{
					...this.props.params,
					search: "",
					page: 1,
				},
				true
			);
		}
	};
	openPage(pageNo) {
		this.props.SetParams({ ...this.props.params, page: pageNo });
		this.props.getORDERLocations({ ...this.props.params, page: pageNo });
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col xs={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom">
										<Link to="/MastersDashboard">
											<i className="ri-arrow-go-back-fill font-size-18"></i>
										</Link>
										<h5 className="card-title-18 d-inline-block ml-2">
											Order Location Master
										</h5>

										<div className="float-right">
											<Button
												type="button"
												color="primary"
												className="waves-effect waves-light"
												tag={Link}
												to="/AddOrderLocations/0">
												Add Order Location
											</Button>
										</div>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md={4}>
												<FormGroup className="m-0">
													<InputGroup>
														<Input
															type="text"
															name="search"
															className="form-control d-inline-block"
															placeholder="Search"
															validate={{
																required: true,
															}}
															onChange={(e) =>
																this.props.SetParams(
																	{
																		...this
																			.props
																			.params,
																		search: e
																			.target
																			.value,
																		page: 1,
																	}
																)
															}
															onKeyDown={(e) =>
																this.handleSearch(
																	e
																)
															}
														/>
														<InputGroupAddon addonType="append">
															<Button
																color="light"
																type="submit"
																onClick={() =>
																	this.props.getORDERLocations(
																		{
																			...this
																				.props
																				.params,
																			page: 1,
																		}
																	)
																}>
																<i className="ri-search-line"></i>
															</Button>
														</InputGroupAddon>
													</InputGroup>
												</FormGroup>
											</Col>
											<Col md={8}>
												<div className="float-right">
													<Pagination aria-label="Page navigation example">
														<PaginationItem
															disabled={
																this.props
																	.params
																	.page <= 1
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		1
																	)
																}
																first
																// href="#"
															/>
														</PaginationItem>

														{this.props.params
															.page > 2 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page <=
																	2
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				2
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page -
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page > 1 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page ===
																	1
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				1
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page -
																		1}
																</PaginationLink>
															</PaginationItem>
														)}

														<PaginationItem
															active={true}>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		this
																			.props
																			.params
																			.page
																	)
																}
																// href="#"
															>
																{
																	this.props
																		.params
																		.page
																}
															</PaginationLink>
														</PaginationItem>
														{this.props.params
															.page +
															1 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		1 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				1
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page +
																		1}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															2 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		2 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				2
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page +
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															3 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 3 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			3 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					3
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			3}
																	</PaginationLink>
																</PaginationItem>
															)}
														{this.props.params
															.page +
															4 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 2 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			4 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					4
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			4}
																	</PaginationLink>
																</PaginationItem>
															)}

														<PaginationItem
															disabled={
																this.props
																	.params
																	.no_of_pages ===
																this.props
																	.params.page
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		this
																			.props
																			.params
																			.no_of_pages
																	)
																}
																last
																// href="#"
															/>
														</PaginationItem>
													</Pagination>
												</div>
											</Col>
										</Row>
										<div
											className="table-responsive m-0"
											style={{
												maxHeight: "550px",
												overflowY: "auto",
											}}>
											<Table
												// striped
												bordered
												hover
												responsive
												className="mb-0 p-0 table-centered">
												<thead className="bg-light text-center">
													<tr>
														<th className="nowrap">
															Code
														</th>
														<th className="nowrap">
															Location
														</th>
														<th className="nowrap">
															Sub Location
														</th>
														<th className="nowrap">
															OrderLocation
														</th>
														<th className="nowrap">
															Action
														</th>
													</tr>
												</thead>
												<tbody>
													{this.props.rowlist
														.length !== 0 ? (
														<>
															{this.props.rowlist.map(
																(
																	subLoc,
																	key
																) => (
																	<tr
																		key={
																			key
																		}>
																		<td className="text-center">
																			{
																				subLoc.code
																			}
																		</td>
																		<td>
																			<h5 className="font-size-14 ">
																				{
																					subLoc
																						.location
																						.name
																				}
																			</h5>
																		</td>
																		<td className="text-center">
																			{
																				subLoc
																					.sublocation
																					.name
																			}
																		</td>
																		<td className="text-center">
																			{
																				subLoc.name
																			}
																		</td>

																		<td className="nowrap text-center">
																			<Link
																				to={`AddOrderLocations/${subLoc.id}`}
																				color="primary">
																				<i
																					className="mdi mdi-pencil-box-outline mr-2 font-size-18"
																					title="Edit Location"
																					style={{
																						cursor: "pointer",
																						color: "#fc6f03",
																					}}></i>
																			</Link>
																			<i
																				className="mdi mdi-delete mr-2 font-size-18"
																				title="Delete location"
																				style={{
																					cursor: "pointer",
																					color: "#ff0000",
																				}}
																				onClick={() =>
																					this.deleteRecord(
																						subLoc.id
																					)
																				}></i>
																		</td>
																	</tr>
																)
															)}
														</>
													) : (
														<>
															<tr>
																<td
																	colspan="4"
																	className="text-center">
																	<span className="font-size-18 text-danger">
																		Data not
																		available
																	</span>
																</td>
															</tr>
														</>
													)}
												</tbody>
											</Table>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { rowlist, model, rowdata, params } = state.orderLocations;
	return { rowlist, model, rowdata, params };
};

export default connect(mapStatetoProps, {
	getORDERLocations,
	ORDERlocationRowData,
	ORDERlocationDelete,
	model_open,
	model_close,
	SetParams,
})(OrderLocations);
